import puzzleFeature from './puzzlesFeature.json';

// One release switch for entry points and search discovery.
// Development exposes the real public and member entries for local review.
export const PUZZLES_ENABLED = puzzleFeature.enabled;

export const PUBLIC_PUZZLES_ENABLED = PUZZLES_ENABLED || process.env.NODE_ENV === "development";

export const MEMBER_PUZZLES_ENABLED = PUBLIC_PUZZLES_ENABLED;
